/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestLWAStartAuthRequest
 */
export interface RequestLWAStartAuthRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestLWAStartAuthRequest
     */
    env: RequestLWAStartAuthRequestEnvEnum;
    /**
     * 任意
     * @type {string}
     * @memberof RequestLWAStartAuthRequest
     */
    scope?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestLWAStartAuthRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestLWAStartAuthRequest
     */
    userId: number;
}


/**
 * @export
 */
export const RequestLWAStartAuthRequestEnvEnum = {
    Prod: 'prod',
    Staging: 'staging'
} as const;
export type RequestLWAStartAuthRequestEnvEnum = typeof RequestLWAStartAuthRequestEnvEnum[keyof typeof RequestLWAStartAuthRequestEnvEnum];


/**
 * Check if a given object implements the RequestLWAStartAuthRequest interface.
 */
export function instanceOfRequestLWAStartAuthRequest(value: object): value is RequestLWAStartAuthRequest {
    if (!('env' in value) || value['env'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestLWAStartAuthRequestFromJSON(json: any): RequestLWAStartAuthRequest {
    return RequestLWAStartAuthRequestFromJSONTyped(json, false);
}

export function RequestLWAStartAuthRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestLWAStartAuthRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'env': json['env'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestLWAStartAuthRequestToJSON(json: any): RequestLWAStartAuthRequest {
    return RequestLWAStartAuthRequestToJSONTyped(json, false);
}

export function RequestLWAStartAuthRequestToJSONTyped(value?: RequestLWAStartAuthRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'env': value['env'],
        'scope': value['scope'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

